module.exports = require("rxjs/observable/fromEvent");


//////////////////
// WEBPACK FOOTER
// external "rxjs/observable/fromEvent"
// module id = 870
// module chunks = 0